import { render, staticRenderFns } from "./SuitGoods.vue?vue&type=template&id=02dac14a&scoped=true"
import script from "./SuitGoods.vue?vue&type=script&lang=js"
export * from "./SuitGoods.vue?vue&type=script&lang=js"
import style0 from "./SuitGoods.vue?vue&type=style&index=0&id=02dac14a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dac14a",
  null
  
)

export default component.exports